export default "__VITE_ASSET__D7H5Z_ao__"